import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id D90C8E93-5B99-4604-A597-5DA45FC3CEB2
 * name movie-settings-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-settings-outline.svg
 * tags
 * - Video / Movie 
 * - Settings 
 */
export const MovieSettingsOutlineIcon = createSvgIcon(<><path d="M18 4L20 8H17L15 4H13L15 8H12L10 4H8L10 8H7L5 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H20C21.11 20 22 19.11 22 18V4H18M20 18H4V6.47L5.76 10H20V18M11 22H13V24H11V22M7 22H9V24H7V22M15 22H17V24H15V22Z" /></>, 'MovieSettingsOutlineIcon');
export default MovieSettingsOutlineIcon